WiseMetering.Views.EditWiseApiConfiguration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration_configuration',
    template: 'templates/integration_configurations/wise_api/edit',
    title: () => i18next.t('modal.title.integration_configurations.edit'),
    ui: {
        state: '#integration_configuration_state'
    },

    onShow: function() {
        const states = WiseMetering.utils.optionsFromArray(
            ['active', 'inactive'].map(state => ({ id: state, name: i18next.t(`glossary.${state}`).capitalize() })),
            this.model.get('state')
        );

        this.ui.state.html(states);
    }
});
